import { view } from '@yola/ws-sdk';

const getTargetElementIdsByQuerySelector = (elementId, querySelector) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const elements = liveElement.matches(querySelector)
    ? [liveElement]
    : liveElement.querySelectorAll(querySelector);

  return [...elements].map((el) => view.accessors.getLiveElementId(el));
};

const getTargetElementIds = (elementId, querySelector) => {
  if (querySelector) {
    return getTargetElementIdsByQuerySelector(elementId, querySelector);
  }

  return [elementId];
};

export default getTargetElementIds;
